import React, { useRef, useState,useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTable from "../../useTable";

import axios from 'axios';
import { Dimmer } from '../../spinner';

export const TablaTributo = (props) => {

    /*  variables de estados */

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([{idcomercio:'', nombre:'', direccion:''}]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });

    const headCells = [
        { id: 'tributo', label: 'TRIBUTO',textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
        { id: 'codigo', label: 'CODIGO',textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
        { id: 'nombre', label: 'NOMBRE',textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
        { id: 'direccion', label: 'DIRECCION',textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff' },
      
    ]


    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        if (props.tipoTributo === 'comercio') {

                setFilterFn({
                    fn: items => {
                        if (target.value === "")
                            return items;
                        else
                            return items.filter(x => {
                                if (x.idcomercio.includes(target.value)
                                || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
                                return x;
                            }
                            })
                    }
                }) 

        } else if (props.tipoTributo === 'inmueble') {

                setFilterFn({
                    fn: items => {
                        if (target.value === "")
                            return items;
                        else
                            return items.filter(x => {
                                if (x.idinmueble.includes(target.value)
                                || x.nombrepropie.toLowerCase().includes(target.value.toLowerCase())) {
                                return x;
                            }
                            })
                    }
                })

        } else  if (props.tipoTributo === 'vehiculo') {

                setFilterFn({
                    fn: items => {
                        if (target.value === "")
                            return items;
                        else
                            return items.filter(x => {
                                if (x.idvehiculo.includes(target.value)
                                || x.nombrepropie.toLowerCase().includes(target.value.toLowerCase())) {
                                return x;
                            }
                            })
                    }
                })
        }


    }

    const seleccionarRegistros = (tabla,orden) => {

      
        let campos = "*"

        setActivate(true);
        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${tabla}&orden=${orden}`;
        console.log(endpoint)
    
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {
    
            if (response.status == 200) {
                setRecords(response.data);
                setActivate(false);
            }
    
        }).catch((error) => {
    
           /*  setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);
     */
        })
    
    }

    const seleccionar = (id,cedrif,nom,direc) => (event) => {

        event.preventDefault();
        props.onHideRenderizar(id,cedrif,nom,direc);
        /* setRecords([{idcomercio:'', nombre:'', direccion:''}]);
        setFilterFn({ fn: items => { return items; } }); */
   

    }

    const cancelar = () => {

        props.onHideCancela();
        setRecords([{idcomercio:'', nombre:'', direccion:''}]);
        setFilterFn({ fn: items => { return items; } });

    }

   /*  useEffect(() => {
      
       
       
      }, []);
 */
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => { 

          /*   if (props.tipoTributo==='comercio') {
                setRecords(props.comercios);
            }else if(props.tipoTributo==='inmueble'){
                setRecords(props.inmuebles);
            }else if(props.tipoTributo==='vehiculo'){
                setRecords(props.vehiculos);
            } */
            seleccionarRegistros(props.tipoTributo,props.nomid)
        
          }}
        >
            <Modal.Header className='azulGradiant'>
                Buscar Contribuyente
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body >
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div>
                    <div className="row" style={{ padding: '10px' }}>
                    <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control search-input rounded-pill" />
</div>
</div>
                    
                    </div>

                    <TblContainer>
                    <TblHead />

                    <tbody>
                      {

                        records && recordsAfterPagingAndSorting().map((item, index) => (
                            ( props.tipoTributo==='comercio' ? 

                          <tr key={index} style={{ padding: "0" }} onClick={seleccionar(item.idcomercio,item.rif,item.nombre,item.direccion)}>
                              <td style={{ textAlign: "center", }}>COMERCIO</td>
                            <td style={{ textAlign: "center",  }}>{item.idcomercio}</td>
                            <td style={{ textAlign: "center",  }}>{item.nombre}</td>
                            <td style={{ textAlign: "center",  }}>{item.direccion}</td>
                           
                          </tr>

                          : props.tipoTributo==='inmueble' ? 

                          <tr key={index} style={{ padding: "0" }} onClick={seleccionar(item.idinmueble,item.cedulapropie,item.nombrepropie,item.descridirinmue1)}>
                              <td style={{ textAlign: "center",  }}>INMUEBLE</td>
                          <td style={{ textAlign: "center",  }}>{item.idinmueble}</td>
                          <td style={{ textAlign: "center",  }}>{item.nombrepropie}</td>
                          <td style={{ textAlign: "center",  }}>{item.dirpropie}</td>
                  
                        </tr>

                        : props.tipoTributo==='vehiculo' ? 

                        <tr key={index} style={{ padding: "0" }} onClick={seleccionar(item.idvehiculo,item.cedulapropie,item.nombrepropie,item.direccionpropie)}>
                            <td style={{ textAlign: "center",  }}>VEHICULO</td>
                        <td style={{ textAlign: "center",  }}>{item.idvehiculo}</td>
                        <td style={{ textAlign: "center",  }}>{item.nombrepropie}</td>
                        <td style={{ textAlign: "center",  }}>{item.direccionpropie}</td>
                      
                      </tr> : ''
                          )
                        ))
                      }
                    </tbody>

                  </TblContainer>
                  <TblPagination />
                </div>

            </Modal.Body>
            <Modal.Footer >
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger col-md-2 rounded-pill"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}